import createIcon from '../../createIcon';

/**
 * @component @name WorkOutline
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE0IDYuNVY0LjVIMTBWNi41SDE0Wk00IDguNVYxOS41SDIwVjguNUg0Wk0yMCA2LjVDMjEuMTEgNi41IDIyIDcuMzkgMjIgOC41VjE5LjVDMjIgMjAuNjEgMjEuMTEgMjEuNSAyMCAyMS41SDRDMi44OSAyMS41IDIgMjAuNjEgMiAxOS41TDIuMDEgOC41QzIuMDEgNy4zOSAyLjg5IDYuNSA0IDYuNUg4VjQuNUM4IDMuMzkgOC44OSAyLjUgMTAgMi41SDE0QzE1LjExIDIuNSAxNiAzLjM5IDE2IDQuNVY2LjVIMjBaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const WorkOutline = createIcon('WorkOutline', [
  [
    'path',
    {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M14 6.5V4.5H10V6.5H14ZM4 8.5V19.5H20V8.5H4ZM20 6.5C21.11 6.5 22 7.39 22 8.5V19.5C22 20.61 21.11 21.5 20 21.5H4C2.89 21.5 2 20.61 2 19.5L2.01 8.5C2.01 7.39 2.89 6.5 4 6.5H8V4.5C8 3.39 8.89 2.5 10 2.5H14C15.11 2.5 16 3.39 16 4.5V6.5H20Z',
      key: '52z9wo',
    },
  ],
]);

export default WorkOutline;
